export default __webpack_public_path__ + "static/media/coverPhoto.9889f3fe.jpg";